import React from 'react'
import {Row,Col} from 'react-bootstrap'
const OurNetworkMb = () => {
  return (
    <>
        <div className="ournetworkmb" data-aos-delay="400" data-aos="fade-up" data-aos-duration="2000">
            <div className="mycontainermb">
            <h4 className='subheading'>Our Network</h4>
                <Row>
                    <Col xs={4}>

                        <img src="./assets/images/Homepage/brands/Spotify.png" alt="" className="w-100" />
                    </Col>
                    <Col xs={4}>

                        <img src="./assets/images/Homepage/brands/Spotify.png" alt="" className="w-100" />
                    </Col>
                    <Col xs={4}>

                        <img src="./assets/images/Homepage/brands/Spotify.png" alt="" className="w-100" />
                    </Col>
                    <Col xs={4}>

                        <img src="./assets/images/Homepage/brands/Spotify.png" alt="" className="w-100" />
                    </Col>
                    <Col xs={4}>

                        <img src="./assets/images/Homepage/brands/Spotify.png" alt="" className="w-100" />
                    </Col>
                    <Col xs={4}>

                        <img src="./assets/images/Homepage/brands/Spotify.png" alt="" className="w-100" />
                    </Col>
                    
                    
                </Row>
            </div>
        </div>
    </>
  )
}

export default OurNetworkMb